import CityPageMosquiteras from "../components/CityPageMosquiteras";

export default function Page() {
  return (
    <CityPageMosquiteras
      name="Benalmádena"
      slug="benalmadena"
      cp="29630, 29631, 29639"
      poblacion={78787}
      zonaGeo="Costa del Sol Occidental"
      lat={36.5988}
      lng={-4.5160}
      zonas={["Benalmádena Costa", "Arroyo de la Miel", "Torrequebrada", "Benalmádena Pueblo"]}
      landmarks={["Puerto Marina", "Castillo de Bil-Bil"]}
      municipiosLimitrofes={["Torremolinos", "Mijas", "Alhaurín de la Torre"]}
      festivalLocal="Virgen del Carmen (16 julio)"
      contextoTipologico="Comunidades extensas en Arroyo de la Miel con instalaciones uniformes de mosquiteras, áticos premium en la Costa con jardines tropicales."
      isCoreZone={true}
    />
  );
}